import React from 'react';
import { IconContext } from 'react-icons';

const ServiceCard = ({ title, description, icon: Icon }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow h-full flex flex-col">
      <div className="flex-shrink-0">
        <IconContext.Provider value={{ className: "text-primary-500 text-4xl mb-4" }}>
          <Icon />
        </IconContext.Provider>
      </div>
      <div className="flex-grow">
        <h3 className="text-xl font-bold text-gray-800 mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default ServiceCard;